<template>
  <div class="adverts jt-wrap">
    <search-adverts
      v-on:addAdverts="addAdverts"
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      :search="search"
    >
    </search-adverts>
    <add-adverts
      v-on:cancel="cancel"
      :showType="showType"
      :adverts="adverts"
      :dialogAdverts="dialogAdverts"
    ></add-adverts>
    <div class="table vue-padding radius" style="overflow: auto" v-loading="loading">
      <el-row :gutter="20" type="flex" justify="start" v-if="advertsList.length > 0">
        <el-col :xl="4" :lg="6" :sm="8" :xs="24" v-for="item in advertsList" :key="item.id">
          <el-card :body-style="{ padding: '0px' }">
            <div class="content">
              <!-- 图片广告 -->
              <el-image
                :src="getImageUrl(item)"
                :preview-src-list="imageList"
                v-if="getRenderType(item) === 0"
                :fit="fit"
                class="image"
              >
                <div slot="placeholder" class="image-slot">
                  <i class="el-icon-loading"></i>
                </div>
                <div slot="error" class="image-slot placeholder-box">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>

              <!-- 视频广告 -->
              <div v-else-if="getRenderType(item) === 1" class="video-container">
                <video-player
                  class="video-player-box vjs-custom-skin"
                  :ref="'videoPlayer-' + item.id"
                  :options="getVideoOptions(item)"
                  :playsinline="true"
                  :key="'player-' + item.id"
                >
                </video-player>
              </div>

              <!-- 网页广告 -->
              <div
                v-else-if="getRenderType(item) === 2"
                class="image web-ad-preview"
                @click.stop="openUrl(item.url)"
                :title="$t('addAdverts.clickToLink')"
              >
                <div class="web-ad-content">
                  <i class="el-icon-link"></i>
                  <div class="url-text">{{ item.url }}</div>
                </div>
              </div>

              <!-- 暂无内容占位 -->
              <div v-else class="image placeholder-box no-data">
                <i class="el-icon-document-delete"></i>
                <div class="tip">{{ $t("common.noData") }}</div>
              </div>

              <div class="info" :data-info-id="item.id">
                <div class="info-container">
                  <div class="ad-info" v-if="item.advertiser">
                    {{ $t("adverts.AddAdverts.649483-24") }}：{{ item.advertiser }}
                  </div>
                  <div class="ad-info" v-if="item.price">
                    {{ $t("adverts.AddAdverts.649483-26") }}：{{ item.price }}
                  </div>
                  <div class="ad-info" v-if="item.notes">
                    {{ $t("adverts.AddAdverts.649483-28") }}：{{ item.notes }}
                  </div>
                </div>
              </div>
            </div>
            <div style="padding: 14px">
              <div class="title" @mouseenter="enter(item.id)" @mouseleave="leave(item.id)">
                {{ item.head ? item.head : $t("common.noTit") }}
              </div>
              <div class="bottom clearfix">
                <time class="time">{{ createTime(item.createTime) }}</time>
                <div class="btn-group">
                  <span class="el-icon-edit" v-hasPerm="['adverts:update']" @click="editAdverts(item)"></span>
                  <span class="el-icon-delete" v-hasPerm="['adverts:delete']" @click="delOneAdverts(item)"></span>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-pagination
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        @size-change="sizeChange"
        :page-size="page.pageSize"
        :page-sizes="[12, 24, 36, 48]"
        :small="true"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import searchAdverts from "_c/adverts/SearchAdverts";
  import addAdverts from "_c/adverts/AddAdverts";
  import "video.js/dist/video-js.css";
  import { videoPlayer } from "vue-video-player";

  export default {
    name: "Adverts",
    components: {
      searchAdverts,
      addAdverts,
      videoPlayer
    },
    data() {
      return {
        dialogAdverts: false,
        advertsList: [],
        advertListOne: [],
        advertListTwo: [],
        loading: false,
        page: {
          pageSize: 12,
          pageIndex: 1
        },
        search: {
          userName: "",
          head: "",
          advertiser: ""
        },
        adverts: {
          id: "",
          head: "",
          type: 0,
          url: "",
          advertiser: "",
          price: "",
          notes: "",
          display: "",
          startTime: "",
          endTime: ""
        },
        showType: [],
        selectId: [],
        imageList: [],
        fit: "cover",
        adHover: "",
        zone: this.$cookies.get("zone")
      };
    },
    mounted() {
      this.currentChange();
      this.listShowType();
    },
    methods: {
      listShowType() {
        this.$api.dict("gp_show_type").then(res => {
          if (res.code === 0) {
            this.showType = res.data;
          }
        });
      },
      addAdverts() {
        this.dialogAdverts = true;
        this.adverts = {
          id: "",
          head: "",
          type: 0,
          url: "",
          advertiser: "",
          price: "",
          notes: "",
          display: "",
          startTime: "",
          endTime: ""
        };
      },

      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },

      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.Adverts.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.advertsList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
              this.imageList = [];
              res.data.records.forEach(k => {
                const imgUrl = this.getImageUrl(k);
                if (this.getRenderType(k) === 0 && imgUrl) {
                  this.imageList.push(imgUrl);
                }
              });
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      editAdverts(row) {
        this.dialogAdverts = true;
        this.adverts = { ...row };
      },
      // 删除广告
      delAdverts(data) {
        this.loading = true;
        this.$api
          .request(this.$url.Adverts.delete, this.$method.delete, { id: data })
          .then(res => {
            if (res.code === 0) {
              this.$notify({
                title: this.$t("common.tip"),
                message: res.msg,
                type: "success"
              });
              this.currentChange(this.page.pageIndex);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },

      delOneAdverts(row) {
        this.$confirm(this.$t("adverts.delete"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.delAdverts(row.id);
        });
      },
      formatterShowType(row) {
        return this.$cloud.getDictLabel(this.showType, row.display);
      },
      createTime(createTime) {
        return createTime;
      },
      cancel(dialog, state) {
        this.dialogAdverts = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      enter(id) {
        const el = document.querySelector(`[data-info-id="${id}"]`);
        if (el) el.style.opacity = "1";
      },
      leave(id) {
        const el = document.querySelector(`[data-info-id="${id}"]`);
        if (el) el.style.opacity = "0";
      },
      openUrl(url) {
        if (url) {
          const fullUrl = url.indexOf("http") === 0 ? url : "https://" + url;
          window.open(fullUrl, "_blank");
        }
      },
      getRenderType(item) {
        const type = item.type !== undefined && item.type !== null && item.type !== "" ? parseInt(item.type) : null;

        if (type === 0) return 0;
        if (type === 1) return 1;
        if (type === 2) return 2;

        // 兜底逻辑：根据字段存在推断
        if (item.showImage) return 0;
        if (item.showVideo) return 1;

        if (item.url) {
          const url = item.url.toLowerCase();
          // 常见的视频扩展名或关键字
          if (url.match(/\.(mp4|m4v|mov|webm|ogv|avi|flv)$/) || url.includes("video") || url.includes("/ad/")) {
            return 1;
          }
          // 常见的图片扩展名
          if (url.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/)) {
            return 0;
          }
          // 其它情况默认为网页广告
          return 2;
        }

        // 终极兜底：遍历所有字段寻找 URL
        for (const key in item) {
          const val = item[key];
          if (typeof val === "string" && val.startsWith("http")) {
            if (val.match(/\.(mp4|m4v|mov|webm)$/) || val.includes("video")) return 1;
            if (val.match(/\.(jpg|jpeg|png|gif)$/)) return 0;
            return 2;
          }
        }

        return -1;
      },
      getVideoOptions(item) {
        let videoUrl = item.url || item.showVideo;
        if (!videoUrl) {
          for (const key in item) {
            const val = item[key];
            if (
              typeof val === "string" &&
              val.startsWith("http") &&
              (val.match(/\.(mp4|m4v|mov|webm)$/) || val.includes("video"))
            ) {
              videoUrl = val;
              break;
            }
          }
        }
        return {
          autoplay: false,
          muted: true,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          aspectRatio: "16:9",
          fluid: true,
          sources: [
            {
              type: "video/mp4",
              src: videoUrl
            }
          ],
          notSupportedMessage: this.$t("common.noData"),
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true
          }
        };
      },
      getImageUrl(item) {
        let url = item.url || item.showImage;
        if (!url) {
          for (const key in item) {
            const val = item[key];
            if (typeof val === "string" && val.startsWith("http") && val.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/)) {
              url = val;
              break;
            }
          }
        }
        return url;
      }
    }
  };
</script>

<style lang="scss">
  .el-dialog__header {
    padding: 20px;
  }

  .el-dialog__body {
    padding: 0 20px;
    height: auto !important;
  }

  .el-dialog__footer {
    padding: 20px;
  }

  .adverts {
    .image,
    .video,
    .web-ad-preview,
    .video-container {
      width: 100%;
      height: 260px;
      cursor: pointer;
      overflow: hidden;
    }

    .video-container {
      background: #000;
      display: flex;
      // align-items: center;
      position: relative;
      z-index: 1;
      .video-player-box {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        ::v-deep .video-js {
          width: 100%;
          height: 100%;
          .vjs-tech {
            object-fit: contain;
          }
        }
      }
    }

    .web-ad-preview {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f7fa;
      color: #909399;
      transition: all 0.3s;
      &:hover {
        background: #e4e7ed;
        color: #409eff;
      }
      .web-ad-content {
        text-align: center;
        padding: 20px;
        i {
          font-size: 40px;
          margin-bottom: 10px;
        }
        .url-text {
          font-size: 12px;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }

    .title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .title:hover {
      cursor: pointer;
    }

    .el-card {
      margin: 5px 0;
    }

    .content {
      position: relative;
      overflow: hidden;
      height: 260px;
      .info {
        position: absolute;
        padding: 10px 20px;
        color: rgba(255, 255, 255, 0.9);
        width: 100%;
        height: 100%;
        left: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        opacity: 0;
        transition: opacity 0.3s;
        pointer-events: none;
        z-index: 2;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        // justify-content: center;
        opacity: 0;
        transition: opacity 0.3s;
        pointer-events: none;
        z-index: 2;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        // justify-content: center;
      }

      // .info-container {
      //   position: relative;
      //   top: 50%;
      //   transform: translateY(-50%);
      // }

      .ad-info {
        // margin: 5px 0;
        animation: advert;
        animation-duration: 0.3s;
        animation-timing-function: linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
      }
    }

    @keyframes advert {
      from {
        transform: translateY(10px);
        opacity: 0;
      }

      to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    .bottom {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;

      .btn-group span {
        margin: 0 5px;
        cursor: pointer;
      }

      .btn-group span:last-child {
        margin-right: 0;
      }

      .el-icon-edit {
        color: #409eff;
      }

      .el-icon-delete {
        color: #f56c6c;
      }
    }

    .image-slot {
      text-align: center;
      width: 100%;
      height: 100%;
      // height: 260px;
      // line-height: 260px;
      background: #f5f7fa;
      color: #909399;
      font-size: 30px;
    }

    .placeholder-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #f5f7fa;
      color: #c0c4cc;
      &.no-data {
        color: #dcdfe6;
        i {
          font-size: 50px;
        }
        .tip {
          font-size: 14px;
          margin-top: 10px;
        }
      }
    }

    // .video-js {
    //   width: 120px !important;
    //   height: 100px !important;
    // }

    .video-js .vjs-big-play-button {
      font-size: 3em;
      line-height: 42px !important;
      height: 50px !important;
      width: 50px !important;
      display: block;
      position: absolute !important;
      left: 50% !important;
      top: 50% !important;
      margin-top: -25px !important;
      margin-left: -25px !important;
      padding: 0;
      cursor: pointer;
      opacity: 1;
      border: 0.06666em solid #fff;
      background-color: #2b333f;
      background-color: rgba(43, 51, 63, 0.7);
      border-radius: 50% !important;
      -webkit-transition: all 0.4s;
      transition: all 0.4s;
    }

    .vjs-paused .vjs-big-play-button,
    .vjs-paused.vjs-has-started .vjs-big-play-button {
      display: block !important;
    }

    .vjs-playing .vjs-big-play-button {
      display: none !important;
    }

    .myVideo-dimensions {
      width: 100% !important;
      height: 100% !important;
      display: block !important;
    }

    .vjs-poster {
      background-size: 100% 100% !important;
    }
  }
</style>
